import { useAuth } from "@/hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Zap, LogOut } from "lucide-react";
import HostDashboard from "@/components/dashboard/HostDashboard";
import DriverDashboard from "@/components/dashboard/DriverDashboard";
import NotificationBell from "@/components/NotificationBell";

const Dashboard = () => {
  const { user, role, loading, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [loading, user, navigate]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-muted-foreground">Lädt…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <nav className="sticky top-0 z-50 border-b border-border bg-background/95 backdrop-blur">
        <div className="container flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary">
              <Zap className="h-5 w-5 text-primary-foreground" />
            </div>
            <span className="text-lg font-semibold text-foreground">chargeflip</span>
          </Link>
          <div className="flex items-center gap-3">
            <NotificationBell />
            <span className="text-sm text-muted-foreground capitalize">{role}</span>
            <Button variant="ghost" size="sm" onClick={signOut} className="gap-2">
              <LogOut className="h-4 w-4" /> Abmelden
            </Button>
          </div>
        </div>
      </nav>

      <div className="container py-8">
        {role === "host" && <HostDashboard />}
        {role === "driver" && <DriverDashboard />}
        {role === "admin" && <p className="text-muted-foreground">Admin-Dashboard wird implementiert.</p>}
      </div>
    </div>
  );
};

export default Dashboard;
